import React from 'react';
import Notifications from 'react-notify-toast';
import Breadcrumbs from '../../../components/Breadcrumbs';
import ErrorMessage from '../../../components/ErrorMessage';
import { Container } from '../../../components/Layout';
import LoadingState from '../../../components/LoadingState';
import alertService from '../../../services/AlertService';
import windowService from '../../../services/windowService';
import { handleError } from '../../../utils/apiUtils';
import { useUser } from '../../authentication';
import { removeVolume } from '../api/removeVolume';
import { useManageCurriculumVolume } from '../hooks/useManageCurriculumVolume';
import { ManageCurriculumVolumeForm } from './ManageCurriculumVolumeForm';
import { VolumeHeadersSection } from './VolumeHeadersSection';

export default function ManageCurriculumVolume() {
  const { user } = useUser();
  const { isLoading, isError, crumbs, curriculum, volume } = useManageCurriculumVolume();

  const redirectBack = () => {
    const previousPage = crumbs[crumbs.length - 2]?.route;
    windowService.redirectTo(previousPage || '/manage-curriculum');
  };

  const handleSubmit = (submitPromise: Promise<void>) => {
    submitPromise
      .then(() => {
        alertService.showOnNextPage('Volume Saved');
        redirectBack();
      })
      .catch(handleError);
  };

  const createRemoveHandler = (volumeId: string, userId: string) => () => {
    removeVolume(volumeId, userId)
      .then(() => {
        alertService.showOnNextPage('Volume Removed');
        redirectBack();
      })
      .catch(handleError);
  };

  return (
    <>
      <Notifications />
      <Breadcrumbs crumbs={crumbs} />
      {isLoading ? (
        <Container>
          <LoadingState />
        </Container>
      ) : isError || !user?.userId || !curriculum ? (
        <Container>
          <ErrorMessage />
        </Container>
      ) : (
        <Container style={{ minHeight: '100vh' }}>
          <ManageCurriculumVolumeForm
            volume={volume}
            curriculum={curriculum}
            userId={user.userId}
            handleSubmit={handleSubmit}
          />
          {volume && volume._id && (
            <VolumeHeadersSection
              headers={volume.sections}
              volumeName={volume.name}
              onRemove={createRemoveHandler(volume._id, user.userId)}
            />
          )}
        </Container>
      )}
    </>
  );
}
